import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import {
  collection,
  getDocs,
  query,
  where,
  orderBy, doc, setDoc, limit, Timestamp, deleteDoc, getDoc
} from "firebase/firestore";
import { db } from "../firebase.js";
import Lodinging from "../components_root/loading.jsx";
import Header from '../body_root/header';
import Footers from '../body_root/footer';
import Navbar from '../body_root/Navbar';
import './message.css';
 
import { Toast } from '../components_root/ToastContext.jsx';
import { MdAccountBox, MdCalculate, MdCalendarMonth, MdCalendarToday, MdCreate, MdDataset, MdInbox, MdMessage, MdOutlineCalendarMonth, MdSend, MdStar, MdStarHalf, MdStarOutline } from 'react-icons/md';
import { Randomcode } from '../components_root/rendom_code.js';
export default function Message_root() {
  const { Toastshow } = Toast();
  const [adminguid, setadminguid] = useState('16ni6A5WWHmFYbu8KJicrSY2MAnFBBPhjS');
  const [send_guid, setsend_guid] = useState('16ni6A5WWHmFYbu8KJicrSY2MAnFBBPhjS');
  const [isLoading, setIsLoading] = useState(true);
  const [islogin, setIslogin] = useState(false);
  const [isallsend, setisallsend] = useState(false);

  const [istab, setistab] = useState("inbox");
  const [tradehistory, setTradeHistory] = useState([]);
  const [notificationdata, setnotificationdata] = useState([]);
  const [guid, setguid] = useState('');
  const [sessiontoken, setsessiontoken] = useState('');
  const [topic, settopic] = useState('');
  const [message, setmessage] = useState('');
  const [from_guid, setfrom_guid] = useState('from');
  const [data, setData] = useState([]);
  useEffect(() => {
    const cookieGuid = Cookies.get("guid");
    const existingsessiontoken = Cookies.get("sessiontoken");
    setfrom_guid(cookieGuid || '');
    setguid(cookieGuid || '');
    if (existingsessiontoken) {
      setsessiontoken(existingsessiontoken);
      setIslogin(true);
    }
  }, []);
  const now = new Date();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  useEffect(() => {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = `${date.getMonth() + 1}`.padStart(2, '0');
      const day = `${date.getDate()}`.padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    setFromDate(formatDate(firstDay));  // 2025-07-01
    setToDate(formatDate(today));       // 2025-07-29
  }, []);
  const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  const lastDayOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);

  const get_notification_system = async () => {
    try {
      setnotificationdata([]);
      setIsLoading(true);
      const userQuery = query(

        collection(db, "notification_system"),
        where("guid", "==", Cookies.get("guid")),
        orderBy("date_time", "desc"),
        limit(20)
      );
      const userSnapshot = await getDocs(userQuery);
      const dataList = userSnapshot.docs.map((doc) => ({
        uid: doc.id,
        ...doc.data(),
      }));
      setnotificationdata(dataList);
    } catch (error) {
      console.error("Error fetching notification data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const get_read_notification_system = async (uid) => {
    try {
      setnotificationdata([]);
      setIsLoading(true);
      const docid = String(uid);
      const userQuery = query(

        collection(db, "notification_system"),
        where("guid", "==", Cookies.get("guid")),
        where("uid", "==", docid)
      );
      const userSnapshot = await getDocs(userQuery);
      const dataList = userSnapshot.docs.map((doc) => ({
        uid: doc.id,
        ...doc.data(),
      }));
      setnotificationdata(dataList);

      try {
        const docRef = doc(db, "notification_system", String(uid));
        await setDoc(docRef, {
          status: true,
          status_date_time: new Date()
        }, { merge: true });
      } catch (error) {
        console.error("Error updating save:", error);
      }
    } catch (error) {
      console.error("Error fetching notification data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const get_read_sent_notification_system = async (uid) => {
    try {
      setnotificationdata([]);
      setIsLoading(true);
      const docid = String(uid);
      const userQuery = query(

        collection(db, "notification_system"),
        where("from_guid", "==", Cookies.get("guid")),

        where("uid", "==", docid), limit(20)
      );
      const userSnapshot = await getDocs(userQuery);
      const dataList = userSnapshot.docs.map((doc) => ({
        uid: doc.id,
        ...doc.data(),
      }));
      setnotificationdata(dataList);
    } catch (error) {
      console.error("Error fetching notification data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const get_saved_system = async () => {
    try {
      // Clear previous data before loading
      setnotificationdata([]);
      setIsLoading(true);

      const userQuery = query(
        collection(db, "notification_system"),
        where("save", "==", true),
        where("guid", "==", Cookies.get("guid")),
        orderBy("date_time", "desc")
      );

      const userSnapshot = await getDocs(userQuery);
      const dataList = userSnapshot.docs.map(doc => ({
        uid: doc.id,
        ...doc.data(),
      }));

      setnotificationdata(dataList);
    } catch (error) {
      console.error("Error fetching notification data:", error);
    } finally {
      setIsLoading(false);
    }
  };


  const get_send_system = async () => {
    setnotificationdata([]);
    setIsLoading(true);
    if (from_guid === guid) {
      try {

        const userQuery = query(
          collection(db, "notification_system"),
          where("from_guid", "==", Cookies.get("guid")),
          orderBy("date_time", "desc"),
          limit(20)
        );
        const userSnapshot = await getDocs(userQuery);
        const dataList = userSnapshot.docs.map((doc) => ({
          uid: doc.id,
          ...doc.data(),
        }));

        setnotificationdata(dataList);
      } catch (error) {
        console.error("Error fetching notification data:", error);
      } finally {
        setIsLoading(false);
      }
    } else {

      try {
        const userQuery = query(
          collection(db, "notification_system"),
          where("guid", "==", Cookies.get("guid")),
          orderBy("date_time", "desc"),
          limit(20)
        );
        const userSnapshot = await getDocs(userQuery);
        const dataList = userSnapshot.docs.map((doc) => ({
          uid: doc.id,
          ...doc.data(),
        }));
        setnotificationdata(dataList);
      } catch (error) {
        console.error("Error fetching notification data:", error);
      } finally {
        setIsLoading(false);
      }
    }
  };
  const get_users_account = async () => {
    try {

      const fromTimestamp = Timestamp.fromDate(new Date(`${fromDate}T00:00:00`));
      const toTimestamp = Timestamp.fromDate(new Date(`${toDate}T23:59:59`));
      const userQuery = query(
        collection(db, "accounts"),
        where("date_time", ">=", fromTimestamp),
        where("date_time", "<=", toTimestamp),
        orderBy("date_time", "asc")
      );

      const userSnapshot = await getDocs(userQuery);
      const dataList = userSnapshot.docs.map((doc) => ({
        uid: doc.id,
        ...doc.data(),
      }));
      setTradeHistory(dataList);
    } catch (error) {
      console.error("Error fetching notification data:", error);
    } finally {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    get_notification_system();
  }, []);

  const get_delete_message = async (uid) => {
    try {
      const docid = String(uid); // Ensure it's a string
      const docRef = doc(db, "notification_system", docid);
      await deleteDoc(docRef);
      // Optionally, refresh notifications
      get_notification_system();
      console.log(`Deleted document with ID: ${docid}`);
    } catch (error) {
      console.error("Error deleting document:", error);
    }
  };
  const set_save = async (uid, newValue) => {
    try {
      const docRef = doc(db, "notification_system", String(uid));
      await setDoc(docRef, { save: newValue }, { merge: true });
      Toastshow("Change to: " + (newValue ? "Saved" : "Removed"));
    } catch (error) {
      console.error("Error updating save:", error);
    }
  };

  const get_send_message = async () => {
    if (!topic) {
      Toastshow("Error Subjact");
      return;
    }

    if (!message) {
      Toastshow("Error Message");
      return;
    }

    if (isallsend == true) {
      const userQuery = query(
        collection(db, "accounts"),
        orderBy("date_time", "asc")
      );
      const userSnapshot = await getDocs(userQuery);
      for (const docSnap of userSnapshot.docs) {
        try {
          const to_guid = docSnap.data().guid; // Correct way to get guid
          const uid = Randomcode(12);
          const savequery = {
            uid,
            guid: to_guid,
            from_guid,
            topic,
            message,
            status: false,
            status_date_time: new Date(),
            save: false,
            date_time: new Date(),
          };
          const docRef = doc(db, "notification_system", uid);
          await setDoc(docRef, savequery, { merge: true });
        } catch (error) {
          console.error("Error sending message:", error);
          Toastshow("Error sending message");
        }
      }
    } else {
      const uid = Randomcode(12);
      try {
        const savequery = {
          uid,
          guid: send_guid,
          from_guid,
          topic,
          message,
          status: false,
          status_date_time: new Date(),
          save: false,
          date_time: new Date(),
        }
        const docRef = doc(db, "notification_system", uid);
        await setDoc(docRef, savequery, { merge: true });
        Toastshow("Sent Successfully");
        setmessage("");
        settopic("");
        setsend_guid(adminguid);
        setistab("inbox");

      } catch (error) {
        console.error("Error sending message:", error);
        Toastshow("Error sending message");
      }
    }
  };
  return (
    <div>
      <Header />
      <div className="container_roots">
        <div className="container_size">
          <br />
          <div className='post-container'>
            <div className='post_updates'>
              <div className='ui-grid'>
                <div onClick={() => {
                  setistab("compose");


                }} className='ui-items hover'>
                  <table className='button-ui3'>
                    <tr >
                      <td><MdCreate className='icon' /></td>
                      <td  >
                        <div
                          className="contact-header bold"
                        >
                          {"Compose message"}
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
                <div onClick={() => {
                  get_notification_system();

                  setistab("inbox");
                }
                } className='ui-items cursor items-back hover'>
                  <table>
                    <tr >
                      <td width={30}><MdInbox className='icon' /></td>
                      <td  >
                        <div
                          className="contact-header  "
                        >
                          Inbox
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
                <div onClick={() => {
                  setistab("sent");
                  get_send_system();
                }
                } className='ui-items cursor items-back hover'>
                  <table>
                    <tr >
                      <td width={30}><MdSend className='icon' /></td>
                      <td  >
                        <div
                          className="contact-header  "
                        >
                          Sent
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
                <div onClick={() => {
                  setistab("saved");
                  get_saved_system();
                }
                } className='ui-items cursor items-back hover'>
                  <table>
                    <tr >
                      <td width={30}><MdStar className='icon' /></td>
                      <td  >
                        <div
                          className="contact-header  "
                        >
                          Saved
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
                {adminguid === guid && (
                  <div onClick={() => { setistab("accounts"); get_users_account(); }} className='ui-items items-back cursor hover'>
                    <table>
                      <tr >
                        <td width={30}><MdAccountBox className='icon' /></td>
                        <td  >
                          <div
                            className="contact-header  "
                          >
                            Users Accounts
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                )}

              </div>

            </div>
            <div className='post_div'>

              {istab === "compose" &&
                <div className='compose-div'>
                  <table>
                    <tbody>
                      <tr>
                        <td className="contact-header bold">Compose your message</td>

                      </tr>
                    </tbody>
                  </table>
                  <br />
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <input
                            style={{ padding: '7px 5px' }}
                            value={topic}
                            onChange={(e) => settopic(e.target.value)}
                            className="contact-header bold"
                            maxLength={60}
                            placeholder='Subject'
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <textarea
                            value={message}
                            onChange={(e) => setmessage(e.target.value)}
                            rows={8}
                            maxLength={2000}
                            placeholder='Enquiry message'
                          />
                        </td>
                      </tr>
                      <tr>
                        {adminguid === guid && (
                          <td width={80} onClick={() => setisallsend(prev => !prev)} className="button-ui2">{isallsend ? "Select All" : "Send This"}</td>
                        )}
                        <td>
                          <div onClick={() => get_send_message()} className='button-ui'>
                            <MdSend className='icon' /> Send
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              }
              {istab === "inbox" &&
                <div>
                  <table>
                    <tbody>
                      <tr>
                        <td className="contact-header bold">Inbox Message</td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                  <div className='ui-grid-fill'>
                    {isLoading ? (
                      <Lodinging />
                    ) : notificationdata.length === 0 ? (

                      <p className="contact-details">Inbox notifications not found.</p>
                    ) : (
                      [...notificationdata].map((row, i) => (
                        <div className='ui-items items-back cursor hover' key={i}>
                          <table onClick={() => { setistab("read"); get_read_notification_system(row.uid) }}>
                            <tbody>
                              <tr>
                                <td><strong className="contact-header bold">{row.topic}</strong></td>
                                <td width={50}>
                                  {row.status === true ? (
                                    <div className="contact-header green">Read
                                    </div>
                                  ) : (
                                    <div className="contact-header red">Unread</div>
                                  )}
                                </td>
                                <td width={22}>
                                  {row.save ? (
                                    <MdStar
                                      className="icon primary"
                                    />
                                  ) : (
                                    <MdStarOutline
                                      className="icon"
                                    />
                                  )}
                                </td>

                              </tr>

                              <tr>
                                <td>
                                  <a className='contact-header'>
                                    <table>
                                      <tbody>
                                        <tr>
                                          <td width={22}><MdOutlineCalendarMonth className='icon' /></td>
                                          <td className='contact-details green'>
                                            {row.date_time?.toDate ? (
                                              <>
                                                {row.date_time.toDate().toLocaleDateString()}{" "}
                                                {row.date_time.toDate().toLocaleTimeString()}
                                              </>
                                            ) : (
                                              <div className='contact-details'>No date</div>
                                            )}
                                          </td>
                                          <td width={180} style={{ fontSize: "11px" }}>{adminguid === guid && <div>From:{row.from_guid}</div>}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              }
              {istab === "saved" &&
                <div>
                  <table>
                    <tbody>
                      <tr>
                        <td className="contact-header bold">Saved Message</td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                  <div className='ui-grid-fill'>
                    {isLoading ? (
                      <Lodinging />
                    ) : notificationdata.length === 0 ? (
                      <p className="contact-details">Saved notifications not found.</p>
                    ) : (
                      [...notificationdata].map((row, i) => (
                        <div className='ui-items items-back cursor hover' key={i}>
                          <table onClick={() => { setistab("read"); get_read_notification_system(row.uid) }}>
                            <tbody>
                              <tr>
                                <td><strong className="contact-header bold">{row.topic}</strong></td>
                                <td width={50}>
                                  {row.status === true ? (
                                    <div className="contact-header green">Read
                                    </div>
                                  ) : (
                                    <div className="contact-header red">Unread</div>
                                  )}
                                </td>

                              </tr>
                              <tr>
                                <td>
                                  <a className='contact-header'>
                                    <table>
                                      <tbody>
                                        <tr>
                                          <td width={22}><MdOutlineCalendarMonth className='icon' /></td>
                                          <td className='contact-details green'>
                                            {row.date_time?.toDate ? (
                                              <>
                                                {row.date_time.toDate().toLocaleDateString()}{" "}
                                                {row.date_time.toDate().toLocaleTimeString()}
                                              </>
                                            ) : (
                                              <div className='contact-details'>No date</div>
                                            )}
                                          </td>
                                          <td width={180} style={{ fontSize: "11px" }}>{adminguid === guid && <div>From:{row.from_guid}</div>}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              }
              {istab === "sent" &&
                <div>
                  <table>
                    <tbody>
                      <tr>
                        <td className="contact-header bold">Sent Message </td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                  <div className='ui-grid-fill'>
                    {isLoading ? (
                      <Lodinging />
                    ) : notificationdata.length === 0 ? (

                      <p className="contact-details">Sent notifications not found.</p>
                    ) : (
                      [...notificationdata].map((row, i) => (
                        <div className='ui-items items-back cursor hover' key={i}>
                          <table onClick={() => { setistab("read"); get_read_sent_notification_system(row.uid) }}>
                            <tbody>
                              <tr>
                                <td><strong className="contact-header bold">{row.topic}</strong></td>
                                <td width={50}>
                                  {row.status === true ? (
                                    <div className="contact-header green">Read
                                    </div>
                                  ) : (
                                    <div className="contact-header bold red">Unread</div>
                                  )}
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <a className='contact-header'>
                                    <table>
                                      <tbody>
                                        <tr>
                                          <td width={22}><MdOutlineCalendarMonth className='icon' /></td>
                                          <td className='contact-details red'>
                                            {row.date_time?.toDate ? (
                                              <>
                                                {row.date_time.toDate().toLocaleDateString()}{" "}
                                                {row.date_time.toDate().toLocaleTimeString()}
                                              </>
                                            ) : (
                                              <div className='contact-details'>No date</div>
                                            )}
                                          </td>
                                          <td width={180} style={{ fontSize: "11px" }}>{adminguid === guid && <div>To:{row.guid}</div>}</td>


                                        </tr>
                                      </tbody>
                                    </table>
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              }
              {istab === "accounts" && <div>

                <table>
                  <tbody>
                    <tr>
                      <td className="contact-header bold">Accounts list</td>
                    </tr>
                  </tbody>
                </table>


                <div className='trade_profit_body'>

                  <br />
                  <table className='table-fixed'>
                    <tr>
                      <th className=''>Accounts ({tradehistory.length})</th>
                      <td width={120}>
                        <input
                          type='date'
                          value={fromDate}
                          onChange={(e) => {
                            setFromDate(e.target.value);
                            get_users_account();
                          }}
                        />
                      </td>

                      <td width={120}>
                        <input
                          type='date'
                          value={toDate}
                          max={new Date().toISOString().split('T')[0]}  // max = today
                          onChange={(e) => { setToDate(e.target.value); get_users_account(); }}
                        />
                      </td>
                      {/* <td width={20} >
                      <MdDownload onClick={() => handleDownload()} className='icon' />
                    </td> */}
                    </tr>

                  </table>

                  {isLoading ? (
                    <Lodinging />
                  ) : tradehistory.length === 0 ? (
                    <div className='contact-details'></div>
                  ) : (

                    <div className="ui-grid grid-fill">
                      <table>
                        <thead>
                          <tr>
                            <th  >Name</th>

                            <th className="balance-column"  >Guid/Email</th>


                          </tr>
                        </thead>

                      </table>
                      {[...tradehistory].reverse().map((row, i) => (
                        <div className="ui-items items-back hover" key={i}>
                          <table >
                            <tbody>
                              <tr >
                                <td >
                                  <table>
                                    <tr>
                                      <td className='contact-header bold'>
                                        {row.name}

                                      </td>
                                    </tr>
                                    <tr>
                                      <td><a style={{ fontSize: "10px" }} className='contact-details'>
                                        {row.date_time?.toDate ? (
                                          <>
                                            {row.date_time.toDate().toLocaleDateString()}{" "}
                                            {row.date_time.toDate().toLocaleTimeString()}
                                          </>
                                        ) : (
                                          "No date"
                                        )}
                                      </a></td>
                                    </tr>

                                  </table>
                                </td>
                                <td className='contact-details' style={{ fontSize: '9px' }}>
                                  <br />
                                  <a className='contact-details'>{row.note}</a>
                                </td>
                                <td width={30} className="balance-column">{row.distanceFromLow?.toFixed(2)}</td>
                                <td width={80} className="balance-column">
                                  <b className='contact-header bold'>{row.amount?.toFixed(5)}</b><br />
                                  <a className='green'>{row.buy_price?.toFixed(5)}</a><br />
                                  <a className='red'>{row.sell_price?.toFixed(5)}</a>
                                </td>

                                <td className="balance-column bold">
                                  <a style={{ fontSize: "11px" }}>Guid:{row.guid}</a><br />
                                  <a style={{ fontSize: "13px" }}>{row.email}</a><br />
                                  {adminguid === guid && (

                                    <div
                                      className="status-ui"
                                      onClick={() => {
                                        setsend_guid(row.guid);
                                        setistab("compose");
                                      }}
                                    >
                                      Reply
                                    </div>

                                  )}
                                </td>

                              </tr>

                            </tbody>
                          </table>
                        </div>
                      ))}
                    </div>


                  )}
                  <br />
                  <div className='report-trmas-div border-top contact-details'>
                    Disclaimer: This report
                    {` ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()} `}
                    is auto-generated by https://btcpayai.com for personal use only and does not serve as an official profit/loss statement or financial certificate; https://btcpayai.com is not liable for any reporting errors, interpretations, or financial decisions based on this data.
                  </div>
                </div>


              </div>}
              {istab === "read" && <div>
                <table>
                  <tbody>
                    <tr>
                      <td className="contact-header bold">Read Message</td>

                    </tr>
                  </tbody>
                </table>
                <br />
                <div className='ui-grid-fill'>
                  {isLoading ? (
                    <Lodinging />
                  ) : notificationdata.length === 0 ? (
                    <p>No notifications found.</p>
                  ) : (
                    [...notificationdata].map((row, i) => (
                      <div className='ui-items items-back' key={i}>
                        <table>
                          <tbody>
                            <tr className='border-bottom'>

                              <td width={122} className='contact-header'>

                                <div>Date:
                                  {row.date_time?.toDate ? (
                                    <>
                                      {row.date_time.toDate().toLocaleDateString()}{" "}
                                      {row.date_time.toDate().toLocaleTimeString()}
                                    </>
                                  ) : (
                                    <div className='contact-details'>No date</div>
                                  )}</div>
                              </td>
                              <td></td>
                              <td
                                width={22}>

                                <tr >
                                  <td
                                    width={22}
                                    onClick={() => {
                                      // instant UI update
                                      setData(prev =>
                                        prev.map(item =>
                                          item.uid === row.uid ? { ...item, save: !item.save } : item
                                        )
                                      );
                                      // Firestore update
                                      set_save(row.uid, !row.save);
                                    }}
                                  >
                                    {row.save ? (
                                      <MdStar className="icon primary" />
                                    ) : (
                                      <MdStarOutline className="icon" />
                                    )}
                                  </td>

                                </tr>


                              </td>
                            </tr>

                            <tr>
                              <td><strong className="contact-header bold">{row.topic}</strong></td>
                            </tr>
                            <tr>
                              <td>
                                <div
                                  className="message_text"
                                  dangerouslySetInnerHTML={{ __html: row.message }}
                                />
                              </td>

                            </tr>
                            <tr >
                              <td className='button-ui2' style={{ display: 'flex', padding: '2px 5px' }}>
                                <MdCalendarMonth className='icon' />
                                {row.status === true && row.date_time && typeof row.date_time.toDate === "function" ? (
                                  <div className="contact-header bold">
                                    Read:{" "}
                                    {row.date_time.toDate().toLocaleDateString()}{" "}
                                    {row.date_time.toDate().toLocaleTimeString()}
                                  </div>
                                ) : (
                                  <div className="contact-header bold green">Read Today</div>
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ fontSize: "12px" }}>{adminguid === guid && <div>From:{row.from_guid} To:{row.guid}</div>}</td>
                            </tr>

                            <tr  >
                              <td>
                                <a className='contact-header'>
                                  <table>
                                    <tbody>

                                      <tr>

                                        {adminguid === guid && (
                                          <td width={70} className="contact-details bold">
                                            <div style={{ padding: '7px 20px' }}
                                              className="status-ui"
                                              onClick={() => {
                                                setsend_guid(row.from_guid);
                                                setistab("compose");
                                              }}
                                            >
                                              Reply
                                            </div>
                                          </td>
                                        )}

                                        {adminguid === guid && (
                                          <td width={50}><div style={{ padding: '7px 20px' }} className='status-ui red-back' onClick={() => {
                                            get_delete_message(row.uid);
                                            setistab("inbox");
                                          }
                                          }>Delete</div></td>
                                        )}
                                      </tr>
                                    </tbody>
                                  </table>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    ))
                  )}
                </div>
              </div>
              }



            </div>

          </div>
        </div>
      </div>
      <Footers />
      <Navbar />
    </div>
  );
}
